export { default as TransferIncomingSolidIcon } from './TransferIncomingSolidIcon';
